import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetsRoutingModule } from './assets-routing.module';
import { AssetListComponent } from './assets-list/asset-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AssetListViewComponent } from './assets-list/asset-list-view/asset-list-view.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { AssetCardViewComponent } from './assets-list/asset-card-view/asset-card-view.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssetListContractComponent } from './assets-list/asset-list-contract/asset-list-contract.component';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AssetDetailComponent } from './asset-detail/asset-detail.component';
import { AssetInspectionModalComponent } from './asset-modals/asset-inspection-modal/asset-inspection-modal.component';
import { AssetDeliveryDelegateModalComponent } from './asset-modals/asset-delivery-delegate-modal/asset-delivery-delegate-modal.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { RequestsModule } from '../my-requests/requests.module';
import { TimeSlotSelectorComponent } from './asset-service-appointment/timeslot-selector/timeslot-selector.component';
import { AppointmentConfirmationComponent } from './asset-service-appointment/appointment-confirmation/appointment-confirmation.component';
import { DaysListComponent } from './asset-service-appointment/timeslot-selector/days-list/days-list.component';
import { AppointmentDataService } from './asset-service-appointment/utils/data-service';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';

@NgModule({
  imports: [
    CommonModule,
    AssetsRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    InputsModule,
    NgbModule,
    QRCodeComponent,
    RequestsModule,
    LayoutModule,
  ],
  declarations: [
    AssetListComponent,
    AssetListViewComponent,
    AssetCardViewComponent,
    AssetListContractComponent,
    AssetDetailComponent,
    AssetInspectionModalComponent,
    AssetDeliveryDelegateModalComponent,

    TimeSlotSelectorComponent,
    AppointmentConfirmationComponent,
    DaysListComponent,
  ],
  providers: [AppointmentDataService],
  exports: [AssetDetailComponent, AssetInspectionModalComponent, AssetDeliveryDelegateModalComponent],
})
export class AssetsModule {}
